const commands = [
  {
    name: '/assign',
    label: 'Assign agents',
    system_name: 'conversations.agents.attach',
    requiredParameters: true,
    description: 'Adds agent to conversation',
  },
  {
    name: '/assign_primary_agent',
    label: 'Set the assigned agent as the primary agent.',
    system_name: 'conversations.agents.attachprimary',
    description: 'Adds primary agent to conversation (ensure primary agent is set)',
  },
  {
    name: '/category',
    label: 'Add categories',
    system_name: 'conversations.categories.attach',
    requiredParameters: true,
    description: 'Assign category to conversation',
  },
  {
    name: '/complete',
    label: 'Close conversation',
    system_name: 'conversations.close',
    description: 'Сomplete conversation',
  },
  {
    name: '/form',
    label: 'Send feedback request',
    system_name: 'conversations.form.trigger',
    description: 'Trigger configured postchat form',
  },
  {
    name: '/lock',
    system_name: 'conversations.lock',
    label: 'Lock conversation to agent',
    requiredParameters: true,
    description: 'Locks conversation',
  },
  {
    name: '/lock_primary_agent',
    label: 'Lock conversation to primary agent',
    system_name: 'conversations.agents.lockprimary',
    description: 'Locks primary agent to conversation',
  },
  {
    name: '/note',
    label: 'Add note',
    system_name: 'conversations.note.attach',
    requiredParameters: true,
    description: 'Adds note to conversation',
  },
  {
    name: '/send_agent_list',
    label: 'Send carousel',
    system_name: 'conversations.messages.agentlist',
    requiredParameters: true,
    optional: true,
    description: 'Send agent selection list',
  },
  {
    name: '/star',
    label: 'Add to agent\'s watch list',
    system_name: 'conversations.star',
    requiredParameters: true,
    description: 'Adds conversation to watchlist',
  },
  {
    name: '/tag',
    label: 'Add tags',
    system_name: 'conversations.tags.attach',
    requiredParameters: true,
    description: 'Assign tag to conversation',
  },
  {
    name: '/team',
    label: 'Add teams',
    system_name: 'conversations.teams.attach',
    requiredParameters: true,
    description: 'Assign team to conversation',
  },
  {
    name: '/trigger_email_form',
    label: 'Send email template',
    system_name: 'conversations.form.email',
    description: 'Trigger email form',
  },
  {
    name: '/unassign',
    label: 'Remove assigned agents',
    system_name: 'conversations.agents.detach',
    requiredParameters: true,
    description: 'Removes agent from conversation',
  },
  {
    name: '/unlock',
    label: 'Unlock conversation',
    system_name: 'conversations.unlock',
    description: 'Unlocks conversation',
  },
  {
    name: '/unstar',
    label: 'Remove from agents\' watch list',
    system_name: 'conversations.unstar',
    requiredParameters: true,
    description: 'Removes conversation from watchlist',
  },
  {
    name: '/unteam',
    label: 'Remove teams',
    system_name: 'conversations.teams.detach',
    requiredParameters: true,
    description: 'Removes team from conversation',
  },
  {
    name: '/workflow',
    label: 'Run workflow',
    system_name: 'bot.workflow.init',
    requiredParameters: true,
    description: 'Run a selected workflow on conversation',
  },
  {
    name: '/enqueue',
    label: 'Add conversation to queue',
    system_name: 'conversations.queue',
    description: 'Enqueue conversation',
  },
  {
    name: '/segment',
    label: 'Add segments',
    system_name: 'customers.segments.attach',
    requiredParameters: true,
    description: 'Assign segment to customer',
  },
  {
    name: '/unsegment',
    label: 'Remove segments',
    system_name: 'customers.segments.detach',
    requiredParameters: true,
    description: 'Remove segment from customer',
  },
  {
    name: '/assign_all_agents',
    label: 'Assign all agents on the team',
    system_name: 'conversations.teams.attachagent',
    description: 'Assign all agents to conversation',
  },
];
export default commands;